import { Component, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationModule } from 'angular-l10n';

@Component({
	selector: 'supplierDB-registration-registration-info',
	standalone: true,
	imports: [L10nTranslationModule],
	templateUrl: './registration-info.component.html',
})
export class RegistrationInfoComponent {
	constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
